<div class="backdrop-overlay">
  <div class="modal-content" [ngStyle]="calculatedStyle()" insResizable [resizeEdges]="resizeEdges">
    <ng-content></ng-content>
  </div>
</div>


